import { CustomerKuspitCredentialsEntity } from '../entities/customer-kuspit-credentials-entity';

export default class State {
  credentials: CustomerKuspitCredentialsEntity = {
    password: '',
    username: '',
  };
}
